import './Segment.scss';

import * as React from 'react';

import bem from '../../utils/bem';

const [block] = bem('time-segment');

const Segment = ({ value, active, onClick }: { value: string; active: boolean; onClick: () => void }): JSX.Element => {
  const modifiers = [active ? 'active' : null];
  return (
    <span className={`${block(modifiers)}`} onMouseDown={(e): void => e.preventDefault()} onClick={onClick}>
      {value}
    </span>
  );
};

export default Segment;
